var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314.09 314.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:var(--active-color);}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_10",
    "data-name": "Livello 10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.57,189.64l2.06-1.63a75.5,75.5,0,0,0,23.28-31.09h0S215.85,68.49,157,29.73c0,0-65.9,52.18-81.56,80,0,0,10.81,39,19.76,49.77,0,0,47.63-45.54,61.8-50.2,0,0,18.34,13.3,26.55,36.41l-28.71,27.21,8.58,11.56,43.24-36.91S184.91,105,157,81.54L102,128.14S114.46,84.15,157,42C157,42,232.05,127.39,249.57,189.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.52,124.44l-2.07,1.63a75.64,75.64,0,0,0-23.28,31.1h0s59.07,88.42,117.88,127.19c0,0,65.9-52.19,81.56-80,0,0-10.82-39-19.76-49.76,0,0-47.65,45.1-61.81,49.76,0,0-18.34-12.86-26.54-36l28.7-27.21-8.57-11.56-43.24,36.91s21.79,42.49,49.66,66L212.14,186s-12.51,44-55.09,86.11C157.05,272.06,82,186.7,64.52,124.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 314.09,
    height: 314.09
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/Geo.ae4f98c60b3868781226105574bd72b6.svg";
export { ForwardRef as ReactComponent };